const localization = {
  en: {
    learnMore: 'Learn more about this',
    error: 'Something went wrong'
  },
  es: {
    learnMore: 'Obtener más información',
    error: 'Ha ocurrido un error'
  },
  keyMapping: {
    // eslint-disable-next-line no-secrets/no-secrets -- localization key, not a secret
    learnMore: 'UFD_Learn_More_About_This',
    error: 'UFD_Error_Text'
  }
}

export default localization
